const files = require.context('./', false, /\.js$/)
const models = {}

files.keys().forEach(key => {
    const fileName = key.replace(/(\.\/|\.js)/g, '')
    if (fileName !== 'index') {
        models[`${fileName}Api`] = files(key)
    }
})

module.exports = models
